<template>
    <div class="introduction-body">
        <div class="introduction-list">
            <div class="introduction" 
                v-for="(n, index) in iconList"
                :class="{jump: !couldJump}"
                :key="index">
                <div class="introduction-image">
                    <img :src="n.image" />
                </div>
                <div class="introduction-msg" v-html="n.name">
                </div>
                <div class="introduction-tips">
                    {{ n.tips }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { iconList } from '../../../images/introduction'
export default {
    data () {
        return {
            iconList,
            couldJump: false
        }
    },
    mounted () {
        setTimeout(() => {
            this.couldJump = true
        }, 500)
    },
    methods: {

    }
}
</script>
<style scoped>
.introduction-body {
    width: 100%;
}
.introduction-list {
    width: 100%;
    box-sizing: border-box;
    padding: 30px 5px;
}
.introduction {
    display: inline-block;
    width: 50%;
    vertical-align: top;
    box-sizing: border-box;
    padding: 5px 0px;
}
.introduction-image {
    display: block;
    height: 80px;
    overflow: hidden;
}
.introduction-image img {
    display: block;
    height: 80px;
    margin: 0 auto;
    transition:  all .5s ease-out;
    animation: jump 1s ease-out;
}
.introduction-msg {
    font-size: 12px;
    color: #000;
    text-align: center;
    margin-top: 5px;
    margin-bottom: 5px;
}
.introduction-tips {
    font-size: 10px;
    color: #010101;
    text-align: center;
    font-family: A-OTF Gothic MB101 Pro;
}
@keyframes jump {
    0% {
        -webkit-transform: translate3d(0, 200px, 0);
        transform: translate3d(0, 200px, 0);
    }
    40% {
        -webkit-transform: translate3d(0, -20px, 0);
        transform: translate3d(0, -20px, 0);
    }
    60% {
        -webkit-transform: translate3d(0, 5px, 0);
        transform: translate3d(0, 5px, 0);
    }
    80% {
        -webkit-transform: translate3d(0, -1px, 0);
        transform: translate3d(0, -1px, 0);
    }
    100% {
        -webkit-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
    }
}
</style>